import React, { useEffect, useRef, memo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { withClient } from '@components';
import { PLATFORMS } from '@constants';
import { trustPilot } from './constants';

import styles from './styles/index.module.scss';

const { templateId, height, width, theme } = trustPilot;

const TrustPilot = memo(({ platform }) => {
  if (platform === PLATFORMS.GERMANY) return null;
  if (platform === PLATFORMS.FRANCE) return null;
  if (platform === PLATFORMS.GREAT_BRITAIN) return null;

  const trustPilotRef = useRef(null);
  const { businessId, dataQa, locale } = trustPilot[platform];

  useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(trustPilotRef.current, true);
    }
  }, []);

  return (
    <div className={styles.container}>
      <div
        ref={trustPilotRef}
        className={cn('trustpilot-widget', styles.trustPilot)}
        data-locale={locale}
        data-businessunit-id={businessId}
        data-template-id={templateId}
        data-style-height={height}
        data-style-width={width}
        data-theme={theme}
        data-qa={dataQa}
      />
    </div>
  );
});

TrustPilot.propTypes = {
  platform: PropTypes.string.isRequired,
};

TrustPilot.displayName = 'TrustPilot';

export default withClient(TrustPilot);
